"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ConstructionProgress = require("./ConstructionProgress");
Object.keys(_ConstructionProgress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ConstructionProgress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConstructionProgress[key];
    }
  });
});